import React, { useState } from 'react';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard } from './shared';

const CashbackCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [price, setPrice] = useState('1.000');
  const [cashback, setCashback] = useState('5');
  const [result, setResult] = useState<any>(null);

  const calculate = () => {
    const p = parseFloat(parseBrazilianNumber(price)) || 0;
    const c = parseFloat(parseBrazilianNumber(cashback)) || 0;
    if (p <= 0) return;

    const val = (p * c) / 100;
    const final = p - val;
    setResult({ val, final });

    onResultChange([
      { label: 'Preço Original', value: `R$ ${p.toLocaleString()}` },
      { label: 'Porcentagem', value: `${c}%` },
      { label: 'Valor Cashback', value: `R$ ${val.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
      { label: 'Preço Efetivo', value: `R$ ${final.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-6 rounded-2xl border border-theme-border text-center">
        <h2 className="text-xl font-black text-theme-text mb-2 tracking-tight">Calculadora de Cashback</h2>
        <p className="text-theme-muted text-sm">Descubra quanto você recebe de volta em suas compras.</p>
      </div>
      <div className="bg-theme-result p-8 rounded-3xl border border-theme-border shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <FormField label="Preço (R$)" value={price} onChange={setPrice} isNumeric required />
          <FormField label="Cashback (%)" value={cashback} onChange={setCashback} isNumeric required />
        </div>
        <div className="flex justify-center mt-8">
          <button onClick={calculate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold shadow-accent hover:scale-105 transition-all">Calcular</button>
        </div>
      </div>
      {result && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <ResultCard title="Recebe de Volta" value={`R$ ${result.val.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="emerald" />
          <ResultCard title="Preço Final" value={`R$ ${result.final.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="indigo" />
        </div>
      )}
    </div>
  );
};

export default CashbackCalculator;
